import { useEffect } from "react";
import { useAppDispatch } from "./storeHooks";
import { useSearchCredsQuery } from "../../../services/matches";
import { ISearchFilter, ISearchSortFilter } from "../../../types/shared";
import { addCreds } from "../reducers/credentialsSlice";
import { notification } from "@findemdev/maui";
import { TabId } from "../components/List/NavigationTabs";


interface IUsePopulateCredsList {
  pageNumber: number;
  joid: string;
  filters?: ISearchFilter[];
  sortFields?: ISearchSortFilter;
  pageSize: number;
  activeTab: TabId;
}

const usePopulateCredsList = ({
  pageNumber,
  joid,
  filters,
  sortFields,
  pageSize = 10,
  activeTab,
}: IUsePopulateCredsList) => {
  const dispatch = useAppDispatch();


  const {
    data: credentialsData,
    isFetching: isCredentialsPending,
    isError: isCredentialsError
  } = useSearchCredsQuery({
    page: pageNumber,
    size: pageSize,
    joid: joid,
    filters: filters,
    activeTab,
    sort_fields: sortFields ? [sortFields] : undefined,
  }, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });

  useEffect(() => {
    if (!isCredentialsPending && credentialsData) {
      dispatch(addCreds(credentialsData.data));
    }
  }, [isCredentialsPending, credentialsData]);

  useEffect(() => {
    if (isCredentialsError) {
      notification.error({
        message: 'Error',
        description: 'Error in fetching Credentials'
      });
    }
  }, [isCredentialsError]);

  return {
    credentialsData,
    isCredentialsPending,
    isCredentialsError
  };
}

export default usePopulateCredsList;